<template>
    <div class="tags-area">
        <div class="container-fluid">
            <div class="card-box-style">
                <div class="others-title">
                    <h3>Default Tags</h3>
                </div>

                <div class="default-tags">
                    <a class="btn btn-primary mb-1 me-1" href="#" role="button">Link</a>
                    <button class="btn btn-primary mb-1 me-1" type="submit">Button</button>
                    <input class="btn btn-primary mb-1 me-1" type="button" value="Input">
                    <input class="btn btn-primary mb-1 me-1" type="submit" value="Submit">
                    <input class="btn btn-primary mb-1 me-1" type="reset" value="Reset">
                </div>
            </div>

            <div class="card-box-style">
                <div class="others-title">
                    <h3>Link Tags</h3>
                </div>

                <div class="default-tags">
                    <a class="btn btn-primary mb-1 me-1" href="#" role="button">Link</a>
                    <a class="btn btn-primary mb-1 me-1" href="#" role="button">Link</a>
                    <a class="btn btn-primary mb-1 me-1" href="#" role="button">Link</a>
                    <a class="btn btn-primary mb-1 me-1" href="#" role="button">Link</a>
                    <a class="btn btn-primary mb-1 me-1" href="#" role="button">Link</a>
                </div>
            </div>

            <div class="card-box-style">
                <div class="others-title">
                    <h3>Rounded Tags</h3>
                </div>

                <div class="default-tags">
                    <a class="btn btn-primary rounded-pill mb-1 me-1" href="#" role="button">Link</a>
                    <button class="btn btn-primary rounded-pill mb-1 me-1" type="submit">Button</button>
                    <input class="btn btn-primary rounded-pill mb-1 me-1" type="button" value="Input">
                    <input class="btn btn-primary rounded-pill mb-1 me-1" type="submit" value="Submit">
                    <input class="btn btn-primary rounded-pill mb-1 me-1" type="reset" value="Reset">
                </div>
            </div>

            <div class="card-box-style">
                <div class="others-title">
                    <h3>Colors Tags</h3>
                </div>

                <div class="colors-tags">
                    <button class="btn btn-primary mb-1 me-1" type="submit">Button</button>
                    <input class="btn btn-secondary mb-1 me-1" type="button" value="Input">
                    <input class="btn btn-success mb-1 me-1" type="submit" value="Submit">
                    <input class="btn btn-danger mb-1 me-1" type="reset" value="Reset">
                    <input class="btn btn-warning mb-1 me-1" type="reset" value="Reset">
                    <input class="btn btn-info mb-1 me-1" type="reset" value="Reset">
                    <input class="btn btn-light mb-1 me-1" type="reset" value="Reset">
                    <input class="btn btn-dark mb-1" type="reset" value="Reset">
                    <a class="btn btn-link mb-1 me-1" href="#" role="button">Link</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TagsContent'
}
</script>

<style lang="scss">
.default-tags {
	.btn {
		background-color: #eeeeee;
		color: var(--heading-color);
	}
}
</style>